var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.163491 9.80053C0.111919 9.86919 0.0876696 9.95454 0.0954433 10.0401C0.103217 10.1256 0.14246 10.2052 0.205566 10.2634L1.47309 11.3975C1.6031 11.5137 1.81275 11.5105 1.93785 11.3887L4.01377 9.38305L5.06247 8.36877L7.19739 6.3051L4.63425 4.01013L0.163491 9.80053ZM9.30029 1.37615C8.77345 0.905273 8.0812 0.662856 7.3757 0.70218C6.6702 0.741505 6.00918 1.05935 5.53794 1.58586C5.0779 2.09952 4.87568 2.74202 4.88331 3.38196L7.79455 5.98822C8.43101 5.92577 9.04747 5.65298 9.50875 5.13891C9.98007 4.61229 10.2229 3.92001 10.1838 3.21435C10.1447 2.5087 9.8269 1.84748 9.30029 1.37615Z",
    fill: "#E8EAED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.84286bf4895f4afe6fe6e5a4c66cddc3.svg";
export { ForwardRef as ReactComponent };